import { render } from "./PointInfoPart.vue?vue&type=template&id=177cdb50&scoped=true"
import script from "./PointInfoPart.vue?vue&type=script&lang=js"
export * from "./PointInfoPart.vue?vue&type=script&lang=js"

import "./PointInfoPart.vue?vue&type=style&index=0&id=177cdb50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177cdb50"]])

export default __exports__